// The job's "רשימות" card — the lists of the tasks that sit on this job, open ones first and
// the done ones under them. A list lives in its task (migration 078); this card only
// gathers the ones about this job and opens each in the same panel the board does.
// "משימה עם רשימה" opens the task dialog with the client, the job and a list already set.
import { useState } from 'react';
import he from '../../i18n/he';
import useAsync from '../../hooks/useAsync';
import { taskListsApi } from '../../api';
import Button from '../../components/Button';
import TaskModal from '../../components/TaskModal';
import ListPanel from '../../components/lists/ListPanel';
import ListLines from '../../components/lists/ListLines';

export default function ListsCard({ job }) {
  const { data, reload } = useAsync(() => taskListsApi.index({ job: job.id }), [job.id]);
  const [panelFor, setPanelFor] = useState(null);
  const [adding, setAdding] = useState(false);
  const rows = data || [];
  const open = rows.filter((r) => r.status !== 'done');
  const done = rows.filter((r) => r.status === 'done');

  return (
    <div className="card w-section">
      <div className="w-head">
        <h2>{he.lists.nav}</h2>
        <Button small variant="ghost" onClick={() => setAdding(true)}>{he.lists.newWithTask}</Button>
      </div>
      {open.length > 0 && <ListLines rows={open} onOpen={setPanelFor} />}
      {done.length > 0 && (
        <>
          <div className="list-subhead">{he.lists.doneGroup}</div>
          <ListLines rows={done} onOpen={setPanelFor} />
        </>
      )}
      {adding && (
        <TaskModal
          task={{ related_client_id: job.client_id, related_job_id: job.id, withList: true }}
          onClose={() => setAdding(false)}
          onSaved={(r) => { setAdding(false); reload(); if (r?.openListFor) setPanelFor(r.openListFor); }}
        />
      )}
      {panelFor && <ListPanel taskId={panelFor} onClose={() => { setPanelFor(null); reload(); }} onChanged={reload} />}
    </div>
  );
}
